/* eslint-disable prettier/prettier */
import skuUtils from "@/internals/sku-utils";
import lookupUtils from "@/internals/lookup-utils";

export function useItemDetailDto(item, selectedAttributeValues) {

    const title = computed(() => {
        if (item && item.value) return item.value.title;
        return '';
    });

    const categoryName = computed(() => {
        if(item.value && item.value.categories?.length) {
            return item.value.categories[0].name;
        }

        return '';
    })
    const primaryImageUrl = computed(() => {
        if (item.value) {
            if (item.value.skus && item.value.skus.length > 0) {
                if (item.value.skus[0].images && item.value.skus[0].images.length > 0) {
                    if (
                        item.value.skus[0].images[0] &&
                        item.value.skus[0].images[0].url &&
                        item.value.skus[0].images[0].url != ''
                    ) {
                        return item.value.skus[0].images[0].url;
                    } else return item.value.skus[0].images[0];
                }
            }
            if (item.value.images && item.value.images.length > 0) {
                if (
                    item.value.images[0] &&
                    item.value.images[0].url &&
                    item.value.images[0].url != ''
                ) {
                    return item.value.images[0].url;
                } else return item.value.images[0];
            }
        }
        return '';
    });

    const design3DUrl = computed(() => {
        // let design3D = `http://${window.location.host}/glb/1.glb`;
        let design3D = "";
        if (item.value) {
            if (item.value?.images?.length) {
                let has3DModel =  item.value?.images.filter(i => i.type == '3D_MODEL' && i.tag == '3D_MODEL');
                if (has3DModel.length) {
                    design3D =  has3DModel[0].url
                }
            }
        }
        return design3D;
    });

    const images = computed(() => {
        let images = [];
        if(item.value?.skus?.length && item.value.skus[0]?.images?.length) {
            item.value.skus.forEach(sku => {
                if(sku.images && sku.images.length > 0) {
                    sku.images.forEach(img => {
                        images.push(img);
                    });
                }
            });
            return [...new Set(images)];
        } else if (item.value?.images?.length) {
            let imgArr = item.value.images.sort((x,y) => x.sortOrder - y.sortOrder);
            imgArr.forEach(image => {
                if (image.type != '3D_MODEL') {
                    images.push(image.url)
                }
            });
            return images;
        }
        return [primaryImageUrl.value];
    });

   const minPrice = computed(() => {
        if (item.value && item.value) {
            let minSkusPrice = 0;
            let minSkusDiscount = 0;
            
            if (item.value && item.value.skus && item.value.skus.length > 0) {

                let priceArray = [];
                let discountArray = [];

                let minPrice = 0;
                let minDiscount = 0;

                item.value.skus.forEach(sku => {
                    priceArray.push(sku.salesPrice)
                    discountArray.push(sku.discountedSalesPrice)
                });

                if (Math.min(...priceArray) > 0) {
                    minPrice = Math.min(...priceArray);
                }

                if (Math.min(...discountArray) > 0) {
                    minDiscount = Math.min(...discountArray);
                }

                if (minPrice > 0) {
                    minSkusPrice = minPrice ;
                }

                if (minDiscount > 0) {
                    minSkusDiscount = minDiscount ;
                }
            }
            
            return {
                salesPrice: Number(item.value && item.value.minPrice ? item.value.minPrice : minSkusPrice),
                discountPrice: Number(item.value && item.value.minDiscountedPrice ? item.value.minDiscountedPrice : minSkusDiscount),
                isDiscountedPriceAvailable: Number(item.value.minDiscountedPrice) > 0 ? true : false,
            };
        }
    });

    const  price = computed(() => {
        if (selectedSku.value) {
            return {
              salesPrice: selectedSku.value.salesPrice,
              discountedPrice: selectedSku.value.discountedSalesPrice,
            };
          }

        return {
            salesPrice:  minPrice.value && minPrice.value.salesPrice ? minPrice.value.salesPrice : 0,
            discountedPrice: minPrice.value && minPrice.value.discountPrice ? minPrice.value.discountPrice : 0,
        };
    });

    const selectedSku = computed(() => {

        if (selectedAttributeValues && selectedAttributeValues.value && selectedAttributeValues.value.length > 0) {
            if (item.value && item.value.skus) {
                let selectedSku = skuUtils.findSkuByAttributeValues(item.value.skus, selectedAttributeValues.value);

                if (selectedSku) {
                    return selectedSku;
                }
            }
            return null;
        } else if (item.value && item.value.skus && item.value.skus.length == 1) {
            let selectedSku = item.value.skus[0];

            return selectedSku;
        } else {

            return null;
        }
    });

    const attributes = computed(() =>  {
        let attributes = skuUtils.extractAttributes(item.value);
        attributes = attributes.sort((a, b) => a.values[0].seq - b.values[0].seq)
        return attributes;
    });

    const lookupGroups = computed(() => {
        if (item.value && item.value.lookups) {
            return lookupUtils.groupLookupsByType(item.value.lookups);
        }
        return {};
    });

    const brands = computed(() => {
        if (lookupGroups.value && lookupGroups.value.brands) {
          return lookupGroups.value.brands.map((b) => b.name);
        }
        return "";
    });

    const  categories = computed(() => {
        if (item.value && item.value.categories) {
          return item.value.categories.map((b) => b.name).join(",");
        }
        return "";
    });

    const bands = computed(() => {
        if (lookupGroups.value && lookupGroups.value.bands) {
          return lookupGroups.value.bands.map((b) => b.name).join(",");
        }
        return "";
    });

    const tags = computed(() => {
        if (item.value && item.value.tags && item.value.tags.length > 0) {
          let tags = item.value.tags;
          return tags;
        }
        return [];
    });

    const keywords = computed(() => {
        if (item.value && item.value.keywords && item.value.keywords.length > 0) {
            let keywords = item.value.keywords;
            return keywords;
        }
        return [];
    });

    return {
        title,
        categoryName,
        primaryImageUrl,
        images,
        design3DUrl,
        minPrice,
        price,
        selectedSku,
        attributes,
        lookupGroups,
        brands,
        categories,
        bands,
        tags,
        keywords
    };
}
